var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import { LinkOnComponent } from 'app/components/links/link';
import { Typography } from '@fupa/fupa-uikit';
import { styled } from '@mui/material/styles';
const FirstMatch = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: -1.25rem;\n"])));
export default function MatchHeaderFirstMatch(_ref) {
  let {
    match
  } = _ref;
  if (!match) {
    return null;
  }
  const hasResult = typeof match.awayGoal === 'number' && typeof match.homeGoal === 'number';
  const firstMatchResult = hasResult ? "".concat(match.awayGoal, ":").concat(match.homeGoal) : /*#__PURE__*/React.createElement("span", null, "\u2013:\u2013");
  return /*#__PURE__*/React.createElement(FirstMatch, {
    "data-sentry-element": "FirstMatch",
    "data-sentry-component": "MatchHeaderFirstMatch",
    "data-sentry-source-file": "MatchHeaderFirstMatch.tsx"
  }, /*#__PURE__*/React.createElement(LinkOnComponent, {
    to: "/match/".concat(match.slug),
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-source-file": "MatchHeaderFirstMatch.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MatchHeaderFirstMatch.tsx"
  }, "Hinspiel: ", firstMatchResult)));
}